import { LineItem } from '@/models/line-item'
import { computed, Ref } from 'vue'
import Big from 'big.js'

export function useLineItemsTotal(lineItems: Ref<LineItem[]> | Ref<undefined>) {
  return computed(() => {
    if (!lineItems.value || lineItems.value.length === 0) return Number(0)

    const total = lineItems.value
      .filter((result) => !!result)
      .reduce((sum, { quantity, rate }) => {
        if (!quantity || !rate) return sum

        const val = new Big(quantity).mul(rate)
        const rounded = val.round(2, Big.roundHalfUp)

        return sum.plus(rounded)
      }, new Big(0))

    return Number(total)
  })
}
